class AffiliateEditView {
  constructor($el) {
    if (!$el.length) return
    this.$root = $el

    this.initSelect2()
    this.$root.on('change', '.js-affiliation-type', this.toggleAffiliateTypeFields.bind(this))
    this.toggleAffiliateTypeFields()
  }

  toggleAffiliateTypeFields() {
    const mode = this.$root.find('.js-affiliation-type').val()

    const $revshare = this.$root.find('.js-revshare')
    const $cpa = this.$root.find('.js-cpa')

    switch (mode) {
      case 'cpa':
        $revshare.toggle(false)
        $cpa.toggle(true)
        break

      case 'recurring':
        $revshare.toggle(true)
        $cpa.toggle(false)
        break
    }
  }

  initSelect2() {
    this.$root.find('.js-select2').select2()
  }
}

document.addEventListener('DOMContentLoaded', function () {
  return new AffiliateEditView($('.affiliate-form'))
})
